export enum AD_RIT {
  esc_used_car_source_list_filter_area_below_ad_banner = '5000070',
  used_car_source_detail_above_similar_car_ad_banner = '5000071',
  esc_car_series_home_featured_used_cars_area_below_ad_banner = '5000072',
  esc_used_car_source_list_bottom_ad_banner = '5000073',
  esc_used_car_source_list_car_source_list_ad_card = '5000074',
  esc_used_car_source_list_ad_home_roof = '5000075',
  // 经销商广告banner
  rit_dealer_ad_home_page_video_bottom = '10000016',
  rit_dealer_ad_home_page_rank_right = '10000017',
  rit_dealer_ad_video_hot_program_bottom = '10000018',
  rit_dealer_ad_video_top_search_bottom = '10000019',
  rit_dealer_ad_message_right = '10000020',
  rit_dealer_ad_car_owner_top = '10000021',
  rit_dealer_ad_car_owner_content_second = '10000022',
  rit_dealer_ad_car_owner_content_eighth = '10000023',
  rit_dealer_ad_car_owner_bottom = '10000024',
  rit_dealer_ad_rank_right = '10000025',
  // 经销商广告文字链
  rit_dealer_ad_video_rank_top = '10000026',
  rit_dealer_ad_article_rank_top = '10000027',
  rit_dealer_ad_video_top_search_rank_top = '10000028',
  rit_dealer_ad_message_top_search_rank_top = '10000029',
  rit_dealer_ad_top_sale_top = '10000030',
}

/**
 * 5000070 二手车车源列表页-筛选区下banner
 * 5000071 二手车车源详情页-车源图下banner
 * 5000072 新车车系详情页-二手车tab内容下banner
 * 5000073 二手车车源列表页-页尾Banner
 * 5000074 二手车车源列表页-第七位卡片
 * 5000075 二手车车源列表页-天幕
 *
 * 经销商广告
 * 10000016 懂车帝PC-首页-视频看车底部banner
 * 10000017 懂车帝PC-首页-右侧文章排行榜底部banner
 * 10000018 懂车帝PC-视频-热门节目底部banner
 * 10000019 懂车帝PC-视频-最新-右侧热搜榜底部banner
 * 10000020 懂车帝PC-资讯-右边栏底部banner
 * 10000021 懂车帝PC-车友圈首页-右边栏-顶部banner第二帧
 * 10000022 懂车帝PC-车友圈首页-内容列表第2位
 * 10000023 懂车帝PC-车友圈首页-内容列表第8位
 * 10000024 懂车帝PC-车友圈首页-右底部banner
 * 10000025 懂车帝PC-排行榜-右侧底部banner
 * 10000026 懂车帝PC-首页-右边栏-视频排行榜顶部文字链
 * 10000027 懂车帝PC-首页-右边栏-文章排行榜顶部文字链
 * 10000028 懂车帝PC-视频-最新-热搜榜顶部文字链
 * 10000029 懂车帝PC-资讯-推荐-热搜榜顶部文字链
 * 10000030 懂车帝PC-排行榜-热销榜顶部文字链
 */
export const LS_AD: { [key in AD_RIT]: string } = {
  '5000070': 'dcd_pc_esc_used_car_source_list_filter_area_below_ad_banner',
  '5000071': 'dcd_pc_esc_used_car_source_detail_above_similar_car_ad_banner',
  '5000072':
    'dcd_pc_esc_car_series_home_featured_used_cars_area_below_ad_banner',
  '5000073': 'dcd_pc_esc_used_car_source_list_bottom_ad_banner',
  '5000074': 'dcd_pc_esc_used_car_source_list_car_source_list_ad_card',
  '5000075': 'dcd_pc_esc_used_car_source_list_ad_home_roof',
  '10000016': 'rit_dealer_ad_home_page_video_bottom',
  '10000017': 'rit_dealer_ad_home_page_rank_right',
  '10000018': 'rit_dealer_ad_video_hot_program_bottom',
  '10000019': 'rit_dealer_ad_video_top_search_bottom',
  '10000020': 'rit_dealer_ad_message_right',
  '10000021': 'rit_dealer_ad_car_owner_top',
  '10000022': 'rit_dealer_ad_car_owner_content_second',
  '10000023': 'rit_dealer_ad_car_owner_content_eighth',
  '10000024': 'rit_dealer_ad_car_owner_bottom',
  '10000025': 'rit_dealer_ad_rank_right',
  '10000026': 'rit_dealer_ad_video_rank_top',
  '10000027': 'rit_dealer_ad_article_rank_top',
  '10000028': 'rit_dealer_ad_video_top_search_rank_top',
  '10000029': 'rit_dealer_ad_message_top_search_rank_top',
  '10000030': 'rit_dealer_ad_top_sale_top',
}

export const EVENTID: { [key in AD_RIT]: string } = {
  '5000070': 'filter_area_below_ad_banner',
  '5000071': 'above_similar_car_ad_banner',
  '5000072': 'featured_used_cars_area_below_ad_banner',
  '5000073': 'bottom_ad_banner',
  '5000074': 'car_source_list_ad_card',
  '5000075': 'ad_home_roof',
  '10000016': 'ad_watching_car_bottm_banner',
  '10000017': 'ad_right_article_bottom_banner',
  '10000018': 'ad_recommend_popular_bottom_banner',
  '10000019': 'ad_new_right_hot_search_banner',
  '10000020': 'ad_right_bottom_banner',
  '10000021': 'ad_right_top_banner',
  '10000022': 'ad_detail_list_position',
  '10000023': 'ad_detail_list_position',
  '10000024': 'ad_right_bottom_banner',
  '10000025': 'ad_right_bottom_banner',
  '10000026': 'ad_right_video_list_top_text',
  '10000027': 'ad_right_video_list_top_text',
  '10000028': 'ad_new_right_hot_search_top_text',
  '10000029': 'ad_recommend_hot_search_top_text',
  '10000030': 'ad_right_hot_sale_text',
}
